/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect, useRef } from "react";

import AuthUser from "../../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../Spinner";

import Swal from "sweetalert2";

import { Alert } from "react-bootstrap";

const CertificadoEditModal = ({ onSubmissionSuccess, certificado, tipo }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();


  const fileInputRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [plano, setPlan] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [curso_id, setCurso] = useState("");
  const [projects, setProjects] = useState([]);
  const [project_id, setProject] = useState(0);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [validators, setValidators] = useState([]);

  const [searchEmployee, setSearchEmployee] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedTraining, setSelectedTraining] = useState("");

  const [uploadedFile, setUploadedFile] = useState(null);

  const [cargos, setCargos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [comapnys, setCompanys] = useState([]);

  const [termo_pesquisa, setSelectedTermoPesquisa] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("-1");
  const [selectedCargo, setSelectedCargo] = useState("-1");
  const [selectedDepartamento, setSelectedDepartamento] = useState("-1");

  useEffect(() => {
    getCursos();
    getColaboradores();
    setSelectedEmployee("");

    setCurso(certificado?.curso_id);
    setSelectedEmployee(certificado?.formando_id);
    setStartDate(certificado?.data_emissao);
    setEndDate(certificado?.data_expiracao);
  }, [certificado]);

  const getColaboradores = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/utilizadores/ativados/" + getMissao()?.id);

      setValidators(res.data.utilizadores);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const getCursos = async () => {
    setLoading(true);

    try {
      const res = await http.get("/listar-cursos-ativos");

      console.log("Cursos  :");
      console.log(res);

      setCursos(res?.data?.cursos);
    } catch (error) {
      setLoading(false);
      console.log("Error loading trainings.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = [
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "text/csv", // .csv
      "application/pdf", // .pdf
    ];

    if (!allowedTypes.includes(file.type)) {
      alert(
        "Formato inválido. Apenas DOC, DOCX, XLS, XLSX, CSV e PDF são permitidos."
      );
      return;
    }

    setUploadedFile(file);
  };

  const handleSubmitEmployeeToEnroll = async () => {
    if (!startDate || !endDate) return notifyError("Fill all dates in form.");

    if (!selectedEmployee || Number(selectedEmployee) <= 0)
      return toast.error("please set an employee.");

    if (!curso_id || Number(curso_id) <= 0)
      return toast.error("please set a training.");

    const start = new Date(startDate).toISOString().split("T")[0];
    const end = new Date(endDate).toISOString().split("T")[0];

    if (end <= start) {
      return notifyError("Expire Date must be later than Emission Date .");
    }

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("ficheiro", uploadedFile);

      formData.append("id", certificado?.id);
      formData.append("curso_id", curso_id);
      formData.append("formando_id", selectedEmployee);
      formData.append("data_emissao", startDate);
      formData.append("data_expiracao", endDate);

      const res = await http.post("/update-certificado-manual", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setLoading(false);

      setSelectedEmployee("");
      setSelectedTraining("");
      setStartDate("");
      setEndDate("");
      setUploadedFile(null);

      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          triggerCloseButtonClick("closeButton30");
          onSubmissionSuccess(res?.data?.certificados);
        },
      });
    } catch (error) {
      console.error(error);
      console.log(error?.message);
      setLoading(false);
    }
  };

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  const handleImageClick = () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="edit_certificado_modal"
        className="modal custom-modal fade modal-lg"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Atualizar certificado")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* OPEN ROW */}
              <div className="row">
                <div className="col-xl-12 mb-3">
                  {loading && (
                    <div className="alert alert-primary text-center my-3">
                      <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                      Carregando...
                    </div>
                  )}
                </div>

                <div className="container-fluid">
                  <div>
                    <label>Upload File</label>

                    <div className="dz-default dlab-message upload-img mb-3">
                      <div className="d-flex align-items-center gap-3">
                        <i
                          width="40"
                          height="40"
                          className="fa fa-upload"
                          alt="File icon"
                          title="Load another file to replace the current one"
                          onClick={handleImageClick}
                          style={{ cursor: "pointer" }}
                        />{" "}
                        <div style={{ display: "none" }}>
                          <input
                            name="file"
                            type="file"
                            accept=".doc,.docx,.xls,.xlsx,.csv,.pdf"
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            className="form-control"
                          />
                          {uploadedFile && (
                            <small className="text-muted">
                              {uploadedFile?.name}
                            </small>
                          )}
                        </div>
                        <a
                          href={
                            url_root+
                            "/storage/certificados/" +
                            certificado?.ficheiro
                          }
                          target="blank"
                        >
                          <i
                            width="40"
                            height="40"
                            className="fa fa-file-pdf"
                            alt="File icon"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <form>
                    {/* Search Employee */}
                    {!loading ? (
                      <>
                        <div className="row">
                          <hr></hr>

                          <div className="col-xl-12 mb-3">
                            {loading && (
                              <div className="alert alert-primary text-center my-3">
                                <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                                Loading...
                              </div>
                            )}
                          </div>

                          <div className="col-xl-12 mb-3">
                            <label className="form-label">
                              Colaboradores{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="default-select form-control"
                              value={selectedEmployee}
                              onChange={(e) =>
                                setSelectedEmployee(e.target.value)
                              }
                            >
                              <option value="">
                                Select [ colaborador - cargo ]
                              </option>
                              {validators.map((validator) => (
                                <option key={validator?.id} value={validator?.id}>
                                  {validator?.name} - {validator?.matricula} - (
                                  {validator?.cargo?.designacao})
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {/* Select Training */}
                    <div className="row">
                      <div className="col-xl-12 mb-3">
                        <label className="form-label">
                          Certificação <span className="text-danger">*</span>
                        </label>

                        <select
                          className="default-select form-control"
                          value={curso_id}
                          onChange={(e) => setCurso(String(e.target.value))}
                        >
                          <option value="">Selecione a certificação</option>
                          {!loading &&
                            cursos.map((curso) => (
                              <option key={curso.id} value={curso.id}>
                                {curso.sigla} - {curso.designacao}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Data de emissão <span className="text-danger">*</span>
                        </label>
                        <input
                          onChange={(e) => setStartDate(e.target.value)}
                          className="form-control"
                          type="date"
                          value={startDate}
                        />
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label
                          htmlFor="exampleFormControlInput8"
                          className="form-label"
                        >
                          Data de expiração{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          onChange={(e) => setEndDate(e.target.value)}
                          className="form-control"
                          type="date"
                          value={endDate}
                        />
                      </div>
                    </div>
                  </form>

                  <div>
                    {loading ? (
                      <button type="button" className="btn btn-primary me-1">
                        <i className="fa fa-spinner fa-spin"></i> Enviando...
                      </button>
                    ) : (
                      <button
                        onClick={handleSubmitEmployeeToEnroll}
                        type="button"
                        className="btn btn-primary me-1"
                      >
                        Atualizar
                      </button>
                    )}
                    <Link
                      href={"#"}
                      onClick={() => setShowModal(false)}
                      className="btn btn-danger light ms-1"
                    >
                      Cancelar
                    </Link>
                  </div>
                </div>

                {/* CLOSE ROW */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}

      <ToastContainer />
    </>
  );
};

export default CertificadoEditModal;
